import React, { forwardRef, useEffect, useImperativeHandle, useState, useCallback } from "react";
import { Suspense } from "react";
import DataLoader from "../../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { useRef } from "react";
import FormCreator from "../../../components/forms/FormCreator";
import Buttons from "../../../components/ui/button/Buttons";
import { AddEXCOMemberData } from "../data/AddExcoMember.Data";
import { useStoreBase64ImageMutation, useAddEditExcoMembersMutation } from "../../../app/services/CommiteeWorkGroup/CommitteWorkGroupServiceApi";
import SwalAlert from "../../../services/swalService/SwalService";
import { onResetForm } from "../../../utils/FormFields/ResetForm/handleResetForm";
import { useLazyGetAllDropDownsForTaskListQuery } from "../../../app/services/PaymentReconciliation/PaymentReconciliationApi";
import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { addExcoMemberConfigs } from "../utils/setDropdownFields";
import ToastService from "../../../services/toastService/ToastService";
import { getImageWebUrl } from "../../../utils/AppSetting";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const AddIndividualRecord = forwardRef((props, ref) => {
  // Destructuring success, error, and confirm alerts from SwalAlert service
  const { success, error, confirm } = SwalAlert();
  const audit = getAuditContext();
  const initState = {
    emailAddress: '',
    // firstName: null,
    // lastName: null,
    displayName: null,
    company: null,
    eXCOPosition: null,
    description: null,
    displayPhotoExpFile: null,
    linkedIn: null
  };
  const addEXCOMemberRef = useRef();
  const [formData, setFormData] = useState(AddEXCOMemberData);
  const [addEditExcoMembers, { isLoading: isAddEditMemberLoading, isSuccess: isAddEditMemberSuccess, data: addEditMemberResponse }] = useAddEditExcoMembersMutation();
  const [getTaskListDropDown, { isLoading: taskListDropDownIsLoading, isSuccess: taskListDropDownIsSuccess, data: taskListDropDownData }] = useLazyGetAllDropDownsForTaskListQuery();
  const [imageUpload, { isLoading: isImageLoading, isSuccess: isImageSuccess, data: uploadImgResponse }] = useStoreBase64ImageMutation();

  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const addEXCOMember = addEXCOMemberRef.current.getFormData();
        return addEXCOMember;
      }
      return null;
    }
  }));

  useEffect(() => {
    onResetForm(formData, setFormData, initState)
    getTaskListDropDown()
  }, []);

  useEffect(() => {
    if (props.isEdit) {
      onResetForm(formData, setFormData, initState)
      getTaskListDropDown()
    }
  }, [props?.isEdit]);

  useEffect(() => {
    if (props?.editIndividualMemberDetails) {

      const { email,
        // firstName, lastName,
        displayName,
        companyName, excoPositionId, encryptedProfileImagePath, designation, linkedIn, profileImagePath } = props?.editIndividualMemberDetails
      const updateFormData = { ...AddEXCOMemberData }
      updateFormData.initialState.emailAddress = email;
      // updateFormData.initialState.firstName = firstName;
      // updateFormData.initialState.lastName = lastName;
      updateFormData.initialState.displayName = displayName;
      updateFormData.initialState.company = companyName;
      updateFormData.initialState.eXCOPosition = excoPositionId;
      updateFormData.initialState.designation = designation;
      updateFormData.initialState.linkedIn = linkedIn;
      updateFormData.initialState.displayPhotoExpFile = `${getImageWebUrl + encryptedProfileImagePath}`;
      setFormData(updateFormData)
    } else {
      onResetForm(formData, setFormData, initState)
    }
  }, [props?.editIndividualMemberDetails]);

  useEffect(() => {
    if (isImageLoading, isImageSuccess, uploadImgResponse) {
      ToastService.success("Image has been uploaded successfully !");
    }
  }, [isImageLoading, isImageSuccess, uploadImgResponse]);

  useEffect(() => {
    if (!isAddEditMemberLoading && isAddEditMemberSuccess && addEditMemberResponse) {
      const successMsg = props?.isEdit ? "Exco member updated successfully." : "Exco member inserted successfully."
      success(successMsg, "Success");
      props?.closeModalPopup()
    }
  }, [isAddEditMemberLoading, isAddEditMemberSuccess, addEditMemberResponse]);


  const handleImageUpload = useCallback((fileDetails) => {
    const request = {
      fileName: fileDetails?.fileName,
      fileStr: fileDetails?.base64Data,
      storagePath: "DisplayPhoto",
    };
    imageUpload(request);
  }, [imageUpload]);

  // Populating dropdown fields once the dropdown data is fetched
  useEffect(() => {
    if (!taskListDropDownIsLoading && taskListDropDownIsSuccess && taskListDropDownData) {
      setAllDropDownFieldsBatch(AddEXCOMemberData, addExcoMemberConfigs, taskListDropDownData);
    }
  }, [taskListDropDownIsLoading, taskListDropDownIsSuccess, taskListDropDownData]);

  const handleActionChange = (action, data, formData) => {
    if (action = 'CLEAR') {
      return;
    }
    else if (formData?.displayPhotoExpFile) {
      handleImageUpload(formData?.displayPhotoExpFile)
    }
  }
  // const handleAddIndividualMember = () => {
  //   const formData = addEXCOMemberRef.current.getFormData();
  //   const { email,
  //     // firstName, lastName, 
  //     displayName,
  //     companyName, excoPositionId, encryptedProfileImagePath, designation, linkedIn, profileImagePath } = props?.editIndividualMemberDetails || formData
  //   if (!formData) {
  //     return error("Please fill all mandatory fields.", "");
  //   }
  //   const request = {
  //     ExcoMemberId: props?.editIndividualMemberDetails?.excoMemberId || null,
  //     // FirstName: formData?.firstName || firstName || null,
  //     // LastName: formData?.lastName || lastName || null,
  //     DisplayName: formData?.displayName || displayName || null,
  //     Email: formData?.emailAddress || email || null,
  //     ExcoPositionId: formData?.eXCOPosition?.value || formData?.eXCOPosition || excoPositionId || null,
  //     SalutationId: "" || null,
  //     WorkGroupMappingId: props?.workgroupMappingId || null,
  //     IPASMemberId: null,
  //     Designation: formData?.designation || designation || null,
  //     LinkedIn: formData?.linkedIn || null,
  //     ProfileImagePath: uploadImgResponse?.uploadedFileName || formData?.displayPhotoExpFile || profileImagePath || null,
  //     EncryptedProfileImagePath: encryptedProfileImagePath || uploadImgResponse?.fileName || null,
  //     CompanyName: formData?.company || companyName || null,
  //     OrderingId: null,
  //   }

  //   addEditExcoMembers(request)
  // }
  const handleAddIndividualMember = () => {
    const formData = addEXCOMemberRef.current.getFormData();

    const {
      email,
      displayName,
      companyName,
      excoPositionId,
      encryptedProfileImagePath,
      designation,
      linkedIn,
      profileImagePath
    } = props?.editIndividualMemberDetails || formData;

    if (!formData) {
      return error("Please fill all mandatory fields.", "");
    }

    const linkedInUrl = formData?.linkedIn?.trim();
    if (linkedInUrl) {
      const isValidLinkedIn = /^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(linkedInUrl);
      if (!isValidLinkedIn) {
        return error("Invalid LinkedIn URL. Please enter a valid LinkedIn profile link.", "404 error");
      }
    }

    const request = {
      ExcoMemberId: props?.editIndividualMemberDetails?.excoMemberId || null,
      DisplayName: formData?.displayName || displayName || null,
      Email: formData?.emailAddress || email || null,
      ExcoPositionId: formData?.eXCOPosition?.value || formData?.eXCOPosition || excoPositionId || null,
      SalutationId: "" || null,
      WorkGroupMappingId: props?.workgroupMappingId || null,
      IPASMemberId: null,
      Designation: formData?.designation || designation || null,
      LinkedIn: linkedInUrl || null,
      ProfileImagePath: uploadImgResponse?.uploadedFileName || formData?.displayPhotoExpFile || profileImagePath || null,
      EncryptedProfileImagePath: uploadImgResponse?.fileName ?? encryptedProfileImagePath,
      CompanyName: formData?.company || companyName || null,
      OrderingId: null,
      CreatedBy: audit.adminUserId,
      CreatedAppId: audit.appId,
    };

    addEditExcoMembers(request);
  };


  // Memoized handler for optimized field changes
  const memoizedHandleFieldChange = (dataFieldName, updateFormData) => {
    if (dataFieldName === "displayPhotoExpFile") {
      return handleImageUpload(updateFormData?.displayPhotoExpFile)
    }
    else {
      return false
    }
  }

  return (
    <div>
      <Suspense fallback={<DataLoader />}>
        <div className="mt-0">
          <FormCreator
            config={formData}
            ref={addEXCOMemberRef}
            key={false}
            onActionChange={handleActionChange}
            onColumnChange={memoizedHandleFieldChange}
          />
        </div>
        <div className="btn-sec ">
          <div className="col-lg-12 d-flex justify-content-between btn-sec mt-2 mb-3">
            <Buttons
              onClick={props?.closeModalPopup}
              buttonText="Cancel"
              buttonTypeClassName="back-btn  btn mt-auto"
            />
            <Buttons
              onClick={handleAddIndividualMember}
              buttonText={props?.isEdit ? "Update" : "Add"}
              buttonTypeClassName="theme-btn btn mt-auto"
              isLoading={isAddEditMemberLoading}
            />
          </div>
        </div>
      </Suspense>
    </div>
  );
})

export default AddIndividualRecord;
